<template>
  <size-table
    v-if="product"
    :product-id="product.code"
    :row-header-fallback="rowHeaderFallback"
    :uid="componentData.uid"
    :content="componentData.content"
  ></size-table>
</template>
<script>
import {mapState} from 'vuex';
import SizeTable from '@/components/SizeTable.vue';
export default {
  name: 'SizingComponent',
  components: {
    SizeTable,
  },
  props: {
    componentData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('productDetails', ['product']),
    rowHeaderFallback() {
      return this.$t('text.variant.size');
    },
  },
};
</script>
